import { isNil } from 'lodash';
// Import Helpers
import { combineUrlParams } from 'services/Helpers';
// Import Configs
import {
    CRMRequestService,
    CRMRequestDownloadLinkService,
    postCancelableRequest,
    CRMRequestServiceDownload,
} from './http.config';

const CommunicationHttpService = {
    getCommunicationList: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            defaultParams: { withTotalCount: true },
            endpointPath: ({ withTotalCount }) => `/Communication/List?withTotalCount=${withTotalCount}`,
        });
    },
    resendCommunication: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: ({ communicationId }) => `/Communication/Send?communicationId=${communicationId}`,
        });
    },
    getPromotionGeneralReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetPromotionGeneralReport`,
        });
    },
    getClickReportByCampaignType: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetClickReportByCampaignType`,
        });
    },
    getOpenReportByCampaignType: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetOpenReportByCampaignType`,
        });
    },
    getTrackedLinks: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetTrackedLinks`,
        });
    },
    getTrackLinkReportByIds: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetTrackLinkReportByIds`,
        });
    },
    downloadTrackLinkReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestServiceDownload,
            endpointPath: () => `/Communication/DownloadTrackLinkReport`,
        });
    },
    downloadClickReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestServiceDownload,
            endpointPath: () => `/Communication/DownloadClickReport`,
        });
    },
    downloadOpenReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestServiceDownload,
            endpointPath: () => `/Communication/DownloadOpenReport`,
        });
    },
    downloadCommunicationsReport: () => {
        return postCancelableRequest({
            requestService: CRMRequestDownloadLinkService,
            endpointPath: ({ isDownload, fileName }) =>
                `/Communication/DownloadCommunicationsReport${combineUrlParams({
                    isDownload,
                    ...(!isNil(fileName) ? { fileName } : {}),
                })}`,
        });
    },
    getUnsubscribeReportByCampaignType: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetUnsubscribeReportByCampaignType`,
        });
    },
    getUnsubscribeClickReportByCampaignType: () => {
        return postCancelableRequest({
            requestService: CRMRequestService,
            endpointPath: () => `/Communication/GetUnsubscribeClickReportByCampaignType`,
        });
    },
};

export default CommunicationHttpService;
